module.exports = __webpack_public_path__ + "static/jamstack-8b93cd5038b1dd9a5505497d365e2777.png";